import {
  getWxWorkJsapiInfo,
  getWechatJsapiInfo,
  getWxWorkAgentJsapiInfo,
  getWechatJsapiInfoByCorpID,
} from "@/api";
import Config from "@/config";
import { getTenantBaseConfig } from "../domainMapping/index";
import { isWeChat } from "./device";
import config from "@/config";
import { address, invoice } from "@/mock/data/wechat";

const wx = window.wx;
const defaultWxWorkJSApiList = ["scanQRCode", "hideOptionMenu", "chooseImage"];
const defaultWxChatJSApiList = [
  "chooseWXPay",
  "onMenuShareTimeline",
  "onMenuShareAppMessage",
  "onMenuShareQQ",
  "onMenuShareWeibo",
  "openLocation",
  "getLocation",
  "chooseImage",
  "previewImage",
  "hideOptionMenu",
  "hideMenuItems",
  "showMenuItems",
  "showOptionMenu",
  "showAllNonBaseMenuItem",
  "hideAllNonBaseMenuItem",
  "scanQRCode",
  "agentConfig",
  "openAddress",
  "chooseInvoiceTitle",
];
const defaultWxWorkAgentJSApiList = [
  "getCurExternalContact",
  "sendChatMessage",
];
/**
 * 配置企微中的微信JSSDK接口
 * @param {string[]} options.jsApiList API名数组
 * @returns Promise<void>
 */
export function wxworkConfig({ jsApiList = defaultWxWorkJSApiList }) {
  return new Promise((resolve, reject) => {
    const workAppid = getTenantBaseConfig().appid;
    const url = Config.isDevelopment
      ? "https://cus-remotesales-dev.linkioapp.com/remote-sales-h5/"
      : location.origin + location.pathname;

    getWxWorkJsapiInfo({
      url: url,
      appId: workAppid,
      debug: 0,
    }).then((res) => {
      const config = {
        debug: false,
        appId: workAppid,
        timestamp: res.timestamp,
        nonceStr: res.nonceStr,
        signature: res.signature,
        jsApiList,
      };

      // console.log("wxworkConfig");
      // console.log(config);
      wx.config(config);
      wx.ready(resolve);
      wx.error((res) => {
        console.log("wx.error", res);
        reject(res);
      });
    });
  });
}
/**
 * 默认的企微端基础配置
 * 会默认处理 wx.hideOptionMenu();
 *
 * 无参数，需要参数应调用 wxworkConfig，并自行处理 wx.hideOptionMenu 等接口调用
 */
export async function useDefaultWxWorkConfig() {
  try {
    await wxworkConfig({
      jsApiList: defaultWxWorkJSApiList,
    });
    wx.hideOptionMenu();
  } catch (err) {
    console.log("useDefaultWxWorkConfig", "授权失败", err);
  }
}

export async function wxCheckJsApiList(jsApiList) {
  return new Promise((resolve, reject) => {
    wx.checkJsApi({
      jsApiList: jsApiList,
      success: function(res) {
        // 以键值对的形式返回，可用的api值true，不可用为false
        // 如：{"checkResult":{"chooseImage":true},"errMsg":"checkJsApi:ok"}
        console.log("✅ wx.checkJsApi: 👇🏻");
        console.log(res);
        resolve(res);
      },
      fail: function (err) {
        console.log("❌ wx.checkJsApi: 👇🏻");
        console.log(err);
        reject(err);
      }
    })
  });
}

/**
 * 配置微信中的微信JSSDK接口
 * @param {string[]} options.jsApiList API名数组
 * @returns Promise<void>
 */
export function wechatConfig({ jsApiList = defaultWxChatJSApiList }) {
  return new Promise((resolve, reject) => {
    const appid = getTenantBaseConfig().wechatAppid;
    const url = Config.isDevelopment
      ? "https://cus-remotesales-dev.linkioapp.com/remote-sales-h5/"
      : location.href.split("#")[0];
    getWechatJsapiInfo({
      url: url,
      appId: appid,
      debug: 0,
    }).then((res) => {
      const config = {
        debug: false,
        beta: true,
        appId: appid,
        timestamp: res.timestamp,
        nonceStr: res.nonceStr,
        signature: res.signature,
        jsApiList,
      };

      wxCheckJsApiList(jsApiList)

      console.log(config);
      wx.config(config);
      wx.ready(resolve);
      wx.error((res) => {
        console.log("wx config error");
        console.log(res);
        reject();
      });
    });
  });
}
/**
 * 默认的微信端基础配置
 * 会默认处理 wx.hideAllNonBaseMenuItem();
 *
 * 无参数，需要参数应调用 wechatConfig wx.hideAllNonBaseMenuItem 等接口调用
 */
export async function useDefaultWeChatConfig() {
  try {
    await wechatConfig({ jsApiList: defaultWxChatJSApiList });
    wx.hideAllNonBaseMenuItem();
  } catch (err) {
    console.log("useDefaultWeChatConfig", "授权失败", err);
    throw { message: err?.message || String(err) };
  }
}

/**
 * 配置企微中的企微JSSDK接口
 * @param {string[]} options.jsApiList API名数组
 * @returns Promise<void>
 */
export function agentConfig({ jsApiList = [] }) {
  return new Promise((resolve, reject) => {
    // 检查wx对象和agentConfig方法是否存在
    if (!wx) {
      console.error("wx对象未定义，请确保企业微信JSSDK已正确加载");
      reject({ message: "企业微信JSSDK未加载" });
      return;
    }
    
    if (typeof wx.agentConfig !== "function") {
      console.error("wx.agentConfig方法不存在，可能是企业微信版本过低");
      reject({ message: "当前企业微信版本过低，请升级后重试" });
      return;
    }

    const url = Config.isDevelopment
      ? "https://cus-remotesales-dev.linkioapp.com/remote-sales-h5/"
      : location.href.split("#")[0];
    // :  location.origin + location.pathname

    getWxWorkAgentJsapiInfo({
      url: url,
      debug: 0,
    }).then((res) => {
      const { agentid, appid } = getTenantBaseConfig();
      const config = {
        debug: false,
        corpid: appid,
        agentid: agentid,
        timestamp: res.timestamp,
        nonceStr: res.nonceStr,
        signature: res.signature,
        jsApiList,
      };

      console.log("agentConfig");
      console.log(config);
      wx.agentConfig({
        ...config,
        success: function (res) {
          console.log("wx.agentConfig success", res);
          resolve(res);
        },
        fail: function (res) {
          console.log("wx.agentConfig fail", res);

          if (res.errMsg.indexOf("function not exist") > -1) {
            reject({ message: "版本过低请升级" });
          } else {
            reject({ message: res?.errMsg || res?.message || String(res) });
          }
        },
      });
    }).catch((err) => {
      console.error("getWxWorkAgentJsapiInfo failed", err);
      reject({ message: "获取企业微信配置失败" });
    });
  });
}
/**
 * 默认的企微端专属配置
 * 需要个性化配置请调用 agentConfig，并自行处理是否调用 useDefaultWxWorkConfig 或 wxworkConfig
 *
 * @param {boolean} isNeedBaseAuth 是否同时调用默认的企微端基础配置，默认为 true
 *
 */
export async function useDefaultWeWorkAgentConfig(isNeedBaseAuth = true) {
  try {
    if (isNeedBaseAuth) {
      await useDefaultWxWorkConfig();
    }
    await agentConfig({ jsApiList: defaultWxWorkAgentJSApiList });
  } catch (err) {
    console.log("getAgentJsapiInfo", "授权失败", err);
  }
}

export async function openAddress() {
  if (!isWeChat && (config.isDevelopAsInWeChat || config.isDevelopAsInWxWork)) {
    return Promise.resolve(address);
  }
  return wechatConfig({ jsApiList: ["openAddress"] }).then(
    () =>
      new Promise((resolve, reject) => {
        wx.openAddress({
          success: function (res) {
            if (res.errMsg === "openAddress:ok") {
              resolve(res);
            } else {
              reject({ type: "error", error: res.errMsg });
            }
          },
          cancel: function (reason) {
            reject({ type: "cancel", reason });
          },
          fail: function (error) {
            reject({ type: "error", error });
          },
        });
      })
  );
}

export function wechatInvoke(name, args) {
  return new Promise((resolve, reject) => {
    wx.invoke(name, args, (res) => {
      try {
        resolve(JSON.parse(JSON.stringify(res)));
      } catch (error) {
        reject({ message: "wx.invoke 数据错误" });
      }
    });
  });
}

export async function chooseInvoiceTitle(scene = "1") {
  if (!isWeChat && (config.isDevelopAsInWeChat || config.isDevelopAsInWxWork)) {
    return Promise.resolve(invoice);
  }
  await wechatConfig({ jsApiList: ["chooseInvoiceTitle"] });
  console.log('test invoice step 1');

  const res = await wechatInvoke("chooseInvoiceTitle", {
    scene,
  });
  console.log('test invoice step 2', res);
  if (res.err_msg === "chooseInvoiceTitle:ok") {
    try {
      return JSON.parse(res.choose_invoice_title_info);
    } catch (error) {
      throw {
        message: "发票信息错误",
      };
    }
  }
  throw {
    message:
      res.err_msg === "chooseInvoiceTitle:fail" ? "选取发票抬头失败" : "",
  };
}

export async function getCurExternalContact() {
  const res = await wechatInvoke("getCurExternalContact", {});
  if (res.err_msg == "getCurExternalContact:ok") {
    return res;
  }
  throw {
    message: "获取失败",
  };
}
